import React from 'react'
import { Grid } from '@mui/material'
import classNames from 'classnames'

import useStyles from '../styles'

const getRandomWidth = () => {
  const min = 160
  const max = 215
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function SkeletonCard() {
  const styles = useStyles()
  const tenantWidth = getRandomWidth()
  const categoryWidth = getRandomWidth()
  const addressWidth = getRandomWidth()

  function Header() {
    return (
      <div className={styles.spacedSection}>
        <div className={styles.headerLeft}>
          <div className={classNames(styles.shimmer, styles.idSkeleton)} />
          <div className={classNames(styles.shimmer, styles.prioritySkeleton)} />
        </div>
        <div className={classNames(styles.shimmer, styles.propertySkeleton)} />
      </div>
    )
  }

  function Content() {
    return (
      <div className={styles.content}>
        <div
          className={classNames(styles.shimmer, styles.tenantSkeleton)}
          style={{ width: `${tenantWidth}px` }}
        />
        <div
          className={classNames(styles.shimmer, styles.categorySkeleton)}
          style={{ width: `${categoryWidth}px` }}
        />
        <div
          className={classNames(styles.shimmer, styles.addressSkeleton)}
          style={{ width: `${addressWidth}px` }}
        />
      </div>
    )
  }

  function Footer() {
    return (
      <div className={styles.footer}>
        <div className={classNames(styles.shimmer, styles.dateSkeleton)} />
        <div className={classNames(styles.shimmer, styles.whatsappSkeleton)} />
      </div>
    )
  }

  return (
    <Grid className={styles.container}>
      <Header />
      <Content />
      <Footer />
    </Grid>
  )
}
